module.exports = __webpack_public_path__ + "static/media/whySales1.c433bfde.png";